import React from "react";
import { Col, Row } from "reactstrap";
import { Link } from "react-router-dom";

function ComputeTabItems(props) {
    return (
        <div className="tab-content">
            <div className="tab-pane active" id="compute">
                <Row className="row">
                    <Col md="4" className="mt-2">
                        <div className="box-content">
                            <p className="box-head">Elastic Compute Server</p>
                            <p className="box-body">
                                Create, develop and launch your business applications on a flexible and secure compute
                                resources on the cloud.
                            </p>
                            <Link className="learn-more" to="/elasticcomputeservice" target="_blank">
                                Learn more <span className="learn-arrow"></span>
                            </Link>
                        </div>
                    </Col>
                    <Col md="4" className="mt-2">
                        <div className="box-content">
                            <p className="box-head">Image Management Service</p>
                            <p className="box-body">
                                You can build cloud servers to meet your requirements from rich pre-configured instance
                                types and resource flavors.
                            </p>
                            <Link className="learn-more" to="/imagemanagementservice" target="_blank">
                                Learn more <span className="learn-arrow"></span>
                            </Link>
                        </div>
                    </Col>
                    <Col md="4" className="mt-2">
                        <div className="box-content">
                            <p className="box-head">Auto-Scaling</p>
                            <p className="box-body">
                                Auto Scaling allows customer to scale the ECS capacity up or down automatically
                                according to the defined conditions
                            </p>
                            <Link className="learn-more" to="/autoscaling" target="_blank">
                                Learn more <span className="learn-arrow"></span>
                            </Link>
                        </div>
                    </Col>
                    <Col md="4" className="mt-2">
                        <div className="box-content">
                            <p className="box-head">Kubernetes Cluster Service</p>
                            <p className="box-body">
                                A high-performance, high-reliability service for enterprises to manage containerized
                                applications.
                            </p>
                            <Link className="learn-more" to="/kubernetesclusterservice" target="_blank">
                                Learn more <span className="learn-arrow"></span>
                            </Link>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    );
}

export default ComputeTabItems;
